var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/task/task-question",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.000000, 4.000000)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path",
    cx: 17.25,
    cy: 17.261,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.375,16.136 C15.375,15.1004661 16.2144661,14.261 17.25,14.261 C18.2855339,14.261 19.125,15.1004661 19.125,16.136 C19.125,17.1715339 18.2855339,18.011 17.25,18.011",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25,20.261 C17.4571068,20.261 17.625,20.4288932 17.625,20.636 C17.625,20.8431068 17.4571068,21.011 17.25,21.011 C17.0428932,21.011 16.875,20.8431068 16.875,20.636 C16.875,20.4288932 17.0428932,20.261 17.25,20.261",
    id: "path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.25,
    y1: 10.511,
    x2: 10.5,
    y2: 10.511,
    id: "path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.25,
    y1: 14.261,
    x2: 8.25,
    y2: 14.261,
    id: "path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.25,
    y1: 18.011,
    x2: 8.25,
    y2: 18.011,
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75,23.261 L2.25,23.261 C1.42157288,23.261 0.75,22.5894271 0.75,21.761 L0.75,6.011 C0.75,5.18257288 1.42157288,4.511 2.25,4.511 L6,4.511 C6,2.43993219 7.67893219,0.761 9.75,0.761 C11.8210678,0.761 13.5,2.43993219 13.5,4.511 L17.25,4.511 C18.0784271,4.511 18.75,5.18257288 18.75,6.011 L18.75,8.261",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75,3.761 C9.95710678,3.761 10.125,3.92889322 10.125,4.136 C10.125,4.34310678 9.95710678,4.511 9.75,4.511 C9.54289322,4.511 9.375,4.34310678 9.375,4.136 C9.375,3.92889322 9.54289322,3.761 9.75,3.761",
    id: "path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskQuestion);
export default __webpack_public_path__ + "static/media/task-question.83f23cd0d009a1012de7e13838672336.svg";
export { ForwardRef as ReactComponent };